import { APPLICATIONS_ID } from "@next-platform/client-common-core/infra/constants/domains";

/**
 * Applications that use the locked subscribe landing flow (/get-access).
 * These apps show the minimal chrome (logo-only header, no side nav, no marketing footer)
 * on the subscribe landing and checkout pages to keep users in the funnel.
 */
export const APPS_WITH_LOCKED_SUBSCRIBE_FLOW = [APPLICATIONS_ID.SecretMate, APPLICATIONS_ID.PixelChat] as const;

/** Query-string marker that activates the locked flow chrome on subscribe/checkout pages. */
export const LOCKED_FLOW_QUERY_KEY = "flow";
export const LOCKED_FLOW_QUERY_VALUE = "locked";
